<template>
  <b-tabs class="block">
    <b-tab-item icon="pie-chart" :label="$t('emissions.t.co2e.short')">
      <b-notification :closable="false">
        {{ $t('compCarbonResultsPlotsGHG.info-1') }}
      </b-notification>
      <highcharts :options="BCRPieDrillDownOptions"></highcharts>
    </b-tab-item>
    <b-tab-item icon="bar-chart" :label="$t('emissions.t.co2e.short')">
      <b-notification :closable="false">
        {{ $t('compCarbonResultsPlotsGHG.info-1') }}
      </b-notification>
      <highcharts :options="BCRColumnDrillDownOptions"></highcharts>
    </b-tab-item>
  </b-tabs>
</template>

<script>
import '@/plugins/highcharts.js'

export default {
  name: 'PlotsGHG',
  props: {
    data0: {
      type: Number,
      default: 100.0
    },
    data1: {
      type: Number,
      default: 100.0
    },
    data2: {
      type: Number,
      default: 100.0
    },
    drill0: {
      type: Array,
      default: function () {
        return []
      }
    },
    drill1: {
      type: Array,
      default: function () {
        return []
      }
    },
    drill2: {
      type: Array,
      default: function () {
        return []
      }
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    const component = this
    return {
      BCRPieDrillDownOptions: {
        chart: {
          type: 'pie'
        },
        title: {
          text: ''
        },
        accessibility: {
          announceNewData: {
            enabled: true
          },
          point: {
            valueSuffix: this.$t('t.co2e')
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              formatter () {
                return `<b>${this.point.name}:</b> ${this.y.toFixed(
                  2
                )} ${component.$t('t.co2e')}`
              }
            }
          }
        },
        tooltip: {
          pointFormatter () {
            return `<b>${this.y.toFixed(2)} ${component.$t('t.co2e')}</b>`
          }
        },
        legend: {
          enabled: false
        },
        series: [
          {
            name: 'Scopes',
            colorByPoint: true,
            data: [
              {
                name: 'Scope 1',
                y: this.data0,
                drilldown: 'scope1',
                color: '#23d160'
              },
              {
                name: 'Scope 2',
                y: this.data1,
                drilldown: 'scope2',
                color: '#ffdd57'
              },
              {
                name: 'Scope 3',
                y: this.data2,
                drilldown: 'scope3',
                color: '#167df0'
              }
            ]
          }
        ],
        drilldown: {
          series: [
            {
              name: 'Scope 1',
              id: 'scope1',
              data: this.drill0,
              zones: [
                {
                  color: '#23d160'
                }
              ]
            },
            {
              name: 'Scope 2',
              id: 'scope2',
              data: this.drill1,
              zones: [
                {
                  color: '#ffdd57'
                }
              ]
            },
            {
              name: 'Scope 3',
              id: 'scope3',
              data: this.drill2,
              zones: [
                {
                  color: '#167df0'
                }
              ]
            }
          ]
        }
      }
    }
  },
  computed: {
    BCRColumnDrillDownOptions () {
      let options = JSON.parse(JSON.stringify(this.BCRPieDrillDownOptions))
      options.chart.type = 'column'
      options.xAxis = {
        type: 'category'
      }
      options.yAxis = {
        title: {
          text: this.$t('emissions.t.co2e')
        }
      }
      options.plotOptions.series = {
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          format: '{point.y:.2f} ' + `${this.$t('t.co2e')}`
        }
      }
      options.tooltip.pointFormatter =
        this.BCRPieDrillDownOptions.tooltip.pointFormatter
      return options
    }
  }
}
</script>
